<template>
  <div class="second-layout">
    <highlight-container
      fluid
      title="Já são mais de 6.700 marcas <br> apoiando a cadeia de reciclagem conosco"
      even
    >
      <p class="text-body ma-0">
        A eu<b>reciclo</b>, através do compromisso de auxiliar as empresas a
        cumprirem a Logística Reversa de Embalagens de forma simples e
        transparente, conquistou diversas marcas engajadas em transformar a
        cadeia de reciclagem no Brasil. Elas carregam nosso sorriso em seus
        rótulos, a fim de comunicar ao consumidor o seu investimento em
        reciclagem por meio da compensação ambiental de suas embalagens. O
        percentual de embalagens compensado pelas empresas varia de 22%, mínimo
        previsto em lei, a 200%. Confira quem são elas!
      </p>
    </highlight-container>
    <highlight-container odd>
      <search-brands />
    </highlight-container>
    <small-companieSection2
      v-if="$route.path === '/empreendedores/marcas'"
      class="introduction"
    />
    <consumer-section2
      v-else-if="$route.path === '/consumidores/marcas'"
      class="introduction"
    />
    <corporation-section2
      v-else-if="$route.path === '/corporacoes/marcas'"
      class="introduction"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'
</style>

<script>
export default {
  name: 'Brands',
  metaInfo: {
    title: 'Marcas',
  },
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    SmallCompanieSection2: () =>
      import('@/components/Section2-Brands/SmallCompanieSection2.vue'),
    ConsumerSection2: () =>
      import('@/components/Section2-Brands/ConsumerSection2.vue'),
    CorporationSection2: () =>
      import('@/components/Section2-Brands/CorporationSection2.vue'),
    SearchBrands: () => import('@/components/SearchBrands.vue'),
  },
};
</script>
